import { Collapsible, Heading, IconButton } from '@components'
import { ChevronDown, ChevronUp, Circle, CircleCheck } from 'lucide-solid'
import { type JSX, type ParentComponent, Show, createSignal } from 'solid-js'
import { css } from 'styled-system/css'
import { Divider, Flex } from 'styled-system/jsx'

interface FieldGroupContainerProps {
	valid: boolean
	heading: string
	actions?: JSX.Element
}

export const FieldGroupContainer: ParentComponent<FieldGroupContainerProps> = (
	props,
) => {
	const [isOpen, setIsOpen] = createSignal(true)

	return (
		<Collapsible.Root
			defaultOpen={isOpen()}
			onOpenChange={({ open }) => setIsOpen(open)}
		>
			<Collapsible.Trigger
				asChild={(triggerProps) => (
					<Flex
						mb="4"
						w="100%"
						gap="4"
						justifyContent="space-between"
						alignItems="center"
					>
						<Flex
							gap="2"
							alignItems="center"
						>
							<Circle
								fill={
									props.valid
										? 'var(--colors-color-palette-11)'
										: 'var(--colors-border-outline)'
								}
								size="20px"
								class={css({
									color: props.valid ? 'tscGreen.11' : 'var(--colors-border-outline)',
								})}
							/>
							<Heading
								size="xl"
								children={props.heading}
							/>
						</Flex>

						<Flex
							justifySelf="end"
							gap="2"
						>
							{props.actions}
							<IconButton
								size="xs"
								variant="outline"
								{...triggerProps()}
							>
								<Show
									when={isOpen()}
									fallback={<ChevronDown />}
								>
									<ChevronUp />
								</Show>
							</IconButton>
						</Flex>
					</Flex>
				)}
			/>
			<Collapsible.Content>
				{props.children}
				<Divider mt={4} />
			</Collapsible.Content>
		</Collapsible.Root>
	)
}
